import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Notebox(props) {
    return (
        <div className="p-100 pb-0">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="boxes_item text-center">
                            <Row>
                                <Col xs={12} md={10} lg={8} xl={8} xxl={8} className="m-auto">
                                    <h2>Cloud POS Solutions Are Disrupting The Retail Industry</h2>
                                    <p><strong>22%</strong> of retail businesses are using cloud-based retail
                                        solutions to streamline their retail operations and deliver an exceptional
                                        experience to the end users.</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Notebox;